const titleCase = (s: string) =>
	s
		?.replace(/^[-_]*(.)/, (_, c) => c.toUpperCase()) // Initial char (after -/_)
		?.replace(/[-_]+(.)/g, (_, c) => " " + c.toUpperCase()); // First char after each -/_

// console.log(titleCase("big_animal"));
// console.log(titleCase("_big_animal___with-more--Nodes"));

export default titleCase;
